/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  MachinePart,
} from '../models/index';
import {
    MachinePartFromJSON,
    MachinePartToJSON,
} from '../models/index';

export interface CreateMachinePartRequest {
    machinePart: MachinePart;
}

export interface CreateMachinePartAltRequest {
    machinePart: MachinePart;
}

export interface DeleteMachinePartRequest {
    id: string;
}

export interface GetMachinePartRequest {
    id: string;
}

export interface UpdateMachinePartRequest {
    id: string;
    machinePart: MachinePart;
}

/**
 * 
 */
export class MachinePartControllerApi extends runtime.BaseAPI {

    /**
     */
    async createMachinePartRaw(requestParameters: CreateMachinePartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MachinePart>> {
        if (requestParameters['machinePart'] == null) {
            throw new runtime.RequiredError(
                'machinePart',
                'Required parameter "machinePart" was null or undefined when calling createMachinePart().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/machine-parts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MachinePartToJSON(requestParameters['machinePart']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MachinePartFromJSON(jsonValue));
    }

    /**
     */
    async createMachinePart(requestParameters: CreateMachinePartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MachinePart> {
        const response = await this.createMachinePartRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createMachinePartAltRaw(requestParameters: CreateMachinePartAltRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MachinePart>> {
        if (requestParameters['machinePart'] == null) {
            throw new runtime.RequiredError(
                'machinePart',
                'Required parameter "machinePart" was null or undefined when calling createMachinePartAlt().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/machinepart`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MachinePartToJSON(requestParameters['machinePart']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MachinePartFromJSON(jsonValue));
    }

    /**
     */
    async createMachinePartAlt(requestParameters: CreateMachinePartAltRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MachinePart> {
        const response = await this.createMachinePartAltRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteMachinePartRaw(requestParameters: DeleteMachinePartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteMachinePart().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/machine-parts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteMachinePart(requestParameters: DeleteMachinePartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteMachinePartRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getAllMachinePartsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MachinePart>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/machine-parts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MachinePartFromJSON));
    }

    /**
     */
    async getAllMachineParts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MachinePart>> {
        const response = await this.getAllMachinePartsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getMachinePartRaw(requestParameters: GetMachinePartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MachinePart>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getMachinePart().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/machine-parts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MachinePartFromJSON(jsonValue));
    }

    /**
     */
    async getMachinePart(requestParameters: GetMachinePartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MachinePart> {
        const response = await this.getMachinePartRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateMachinePartRaw(requestParameters: UpdateMachinePartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MachinePart>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateMachinePart().'
            );
        }

        if (requestParameters['machinePart'] == null) {
            throw new runtime.RequiredError(
                'machinePart',
                'Required parameter "machinePart" was null or undefined when calling updateMachinePart().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/machine-parts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MachinePartToJSON(requestParameters['machinePart']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MachinePartFromJSON(jsonValue));
    }

    /**
     */
    async updateMachinePart(requestParameters: UpdateMachinePartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MachinePart> {
        const response = await this.updateMachinePartRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
